import { ratingConstants, ratingRange } from 'shared/constants/company';
import { portfolioTypes } from 'shared/constants/portfolioTypes';

export const scalesTypes = {
  rs1: 'RS1',
  rs2: 'RS2',
  rs3: 'RS3',
  rs4: 'RS4',
};

const creditRatingScales = {
  [scalesTypes.rs1]: [
    {
      value: 'C',
      tooltip: 'Ratings at the C level reflect an opinion of exceptionally weak credit quality.',
    },
    {
      value: 'CC',
      tooltip: 'Ratings at the CC level reflect an opinion of extremely weak credit quality.',
    },
    {
      value: 'CCC',
      tooltip: 'Ratings at the CCC level reflect an opinion of very weak credit quality.',
    },
    {
      value: 'B',
      tooltip: 'Ratings at the B level reflect an opinion of weak credit quality.',
    },
    {
      value: 'BB',
      tooltip: 'Ratings at the BB level reflect an opinion of moderate credit quality.',
    },
    {
      value: 'BBB',
      tooltip: 'Ratings at the BBB level reflect an opinion of good credit quality.',
    },
    {
      value: 'A',
      tooltip: 'Ratings at the A level reflect an opinion of strong credit quality.',
    },
    {
      value: 'AA',
      tooltip: 'Ratings at the AA level reflect an opinion of very strong credit quality.',
    },
    {
      value: 'AAA',
      tooltip: 'Ratings at the AAA level reflect an opinion of exceptionaly strong credit quality.',
    },
  ],
  [scalesTypes.rs2]: [
    {
      value: 'S-4',
      tooltip:
        'Ratings at the S-4 level reflect an opinion of moderate-to-high credit risk with modest capacity to repay short-term obligations.',
    },
    {
      value: 'S-3',
      tooltip:
        'Ratings at the S-3 level reflect an opinion of acceptable credit risk with fair capacity to repay short-term obligations.',
    },
    {
      value: 'S-2',
      tooltip:
        'Ratings at the S-2 level reflect an opinion of low credit risk with good capacity to repay short-term obligations.',
    },
    {
      value: 'S-1',
      tooltip:
        'Ratings at the S-1 level reflect an opinion of very low credit risk with high capacity to repay short-term obligations.',
    },
    {
      value: 'S-1+',
      tooltip:
        'Ratings at the S-1+ level reflect an opinion of the lowest credit risk with the highest capacity to repay short-term obligations.',
    },
  ],
  [scalesTypes.rs3]: [
    {
      value: '0',
    },
    {
      value: '1',
    },
    {
      value: '2',
    },
    {
      value: '3',
    },
    {
      value: '4',
    },
    {
      value: '5',
    },
    {
      value: '6',
    },
    {
      value: '7',
    },
    {
      value: '8',
    },
    {
      value: '9',
    },
    {
      value: '10',
    },
  ],
  [scalesTypes.rs4]: [
    {
      value: '0',
      tooltip: 'Payment Default',
    },
    {
      value: '1',
      tooltip:
        'Extremely High Risk - The risk of payment default is very high and company liquidity is too low. Deliveries on credit terms are not recommended.',
    },
    {
      value: '2',
      tooltip:
        'Very High Risk - The risk of payment default is very high and company solvency is very poor. The economic situation is critical.',
    },
    {
      value: '3',
      tooltip:
        'High Risk - The company exhibits a bad financial situation. The risk of payment default is high. The company is not able to react in time to a deterioration in the credit situation.',
    },
    {
      value: '4',
      tooltip:
        'Heighted Risk - The financial stability is below the average. The risk of payment default is higher than average. A high exposure to external events.',
    },
    {
      value: '5',
      tooltip:
        'Medium Risk - The financial capacity and stability of large companies or corporations is slightly below average. For mid-sized companies it is normal. The risk of payment default represents the average.',
    },
    {
      value: '6',
      tooltip:
        'Average Credit Score - There is an average risk of payment default. Changes to credit ratings should be monitored closely. An appropriate amount of time will be required for the company to be able to react to a deterioration in the economic climate.',
    },
    {
      value: '7',
      tooltip:
        'Stable, slightly above average Credit Score - The risk of payment default is relatively small and the company solvency is stable.The company should, given an appropriate amount of time, be able to react to any deterioration in the economic climate.',
    },
    {
      value: '8',
      tooltip:
        'Good Credit Score - The risk of payment default is small and company solvency is good. The company is able to withstand unforseen events.',
    },
    {
      value: '9',
      tooltip:
        'High Credit Score - The risk of payment default is very small and the financial stability of the company is very high. The company exibits a high ability to withstand unforseen events.',
    },
    {
      value: '10',
      tooltip:
        'Very high Credit Score - The risk of payment default is very small und company solvency is very good. The company exibits a very high ability to withstand unforseen events.',
    },
  ],
};
export const creditRatingScalesMap = {
  [portfolioTypes.CREDIT_RATING]: {
    [ratingConstants.entityRatingCurrency]: scalesTypes.rs1,
    [ratingConstants.entityReview]: scalesTypes.rs1,
    [ratingConstants.longTermRating]: scalesTypes.rs1,
    [ratingConstants.longTermRatingCurrency]: scalesTypes.rs1,
    [ratingConstants.entityRating]: scalesTypes.rs1,
    [ratingConstants.rating]: scalesTypes.rs1,
    [ratingRange.longTermRange]: scalesTypes.rs1,
    [ratingRange.undeterminedRange]: scalesTypes.rs1,
    [ratingRange.shortTermRange]: scalesTypes.rs2,
  },
  [portfolioTypes.CREDIT_REVIEW]: {
    [ratingConstants.entityReview]: scalesTypes.rs4,
  },
  [portfolioTypes.ESG_ANALYSIS]: {
    [ratingConstants.entityReview]: scalesTypes.rs3,
  },
};

export const creditRatingScalesMapping = (portfolioType, ratingType) =>
  creditRatingScales[creditRatingScalesMap[portfolioType][ratingType]];
